/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Dialog } from 'primereact/dialog';
import { InputText  } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';

class DomainModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      domain: '',
      errors: [],
      justification: ''
    }
  }

  componentDidMount() {
    this.setState({
      domain: this.props.value || '',
      loadingPage: false
    })
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const { onContinueAction, onHidden } = this.props
    const { domain, justification } = this.state
    const validate = await this.validateFieldsReject()
    if (some(validate, {})) return true
    onContinueAction({domain}, justification)
    return onHidden()
  }

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFieldsReject = async () => {
    const { t, label } = this.props
    const { domain, justification } = this.state
    let errors = {}
    if (!domain) errors = { ...errors, 'domain': `${t( label || 'Dominio')} ${t('es requerido')}`}
    if (!justification) errors = { ...errors, 'justification': `${t('Justificación del cambio')} ${t('es requerido')}`}

    this.setState({errors})
    return errors
  }

  isFormFieldValid = (name) =>
    !!(this.state.errors[name]);

  getFormErrorMessage = (name) =>
    this.isFormFieldValid(name) && (
      <small className="p-error">{this.state.errors[name]}</small>
    );
  
  render () {
    const { t, display, title, onHidden, label, btnOkLabel, description } = this.props
    const { domain, loadingPage } = this.state

    const children = loadingPage ? '' : (
      <form className="p-mt-2 p-fluid" onSubmit={this.onSubmit}>
        <div className="p-col">
          <label className="">{description}</label>
        </div>
        <div className="p-col">
          <label className="">{label || t('Dominio')}</label>
        </div>
        <div className="col-12 md:col-4">
          <InputText
            name="domain"
            onChange={(e) =>
              this.setState({ domain: e.target.value }, this.validateFieldsOnchange('domain', e.target.value))
            }
            value={domain}
            className={classNames({
              'p-invalid': this.isFormFieldValid(`domain`),
            })}
          />
          {this.getFormErrorMessage(`domain`)}
        </div>

        <div className='p-col-12'>
            <label className="">{t('Justificación del cambio')}</label>
            <InputTextarea
              name="justification"
              onChange={(e) =>
                this.setState({ justification: e.target.value }, this.validateFieldsOnchange('justification', e.target.value))
              }
              rows={5}
              cols={30}
              className={classNames({
                'p-invalid': this.isFormFieldValid(`justification`),
              })}
            />
          {this.getFormErrorMessage(`justification`)}
        </div>
        <div className="p-dialog-footer custom">
          <div>
            <button className="p-button p-component p-button-raised p-button-secondary p-button-text" type="button" onClick={() => onHidden()}>
              <span className="p-button-label p-c">{t('Cerrar')}</span>
            </button> 
            <button className="p-button p-component" type="submit">
              <span className="p-button-label p-c">{btnOkLabel || 'Continuar'}</span>
            </button>
          </div>
        </div>
      </form>
    )
    if (loadingPage) return true;

    return (
      <Dialog
        header={title || t('Dominio')}
        visible={display}
        breakpoints={{'960px': '90vw'}}
        style={{ width: '30vw' }}
        onHide={onHidden}
      >
        {children}
      </Dialog>
    )
  }
}



export default compose(
  withTranslation()(DomainModal))